import LogoIcon from "@/core/components/logo-icon";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface ErrorStateProps {
  error?: string | null;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => (
  <Stack
    align="center"
    fullWidth
    className="m-auto min-h-screen max-w-md bg-card p-8"
    gap="xl"
  >
    <LogoIcon />
    <Typography variant="subtitleW1" className="text-center">
      An error occurred
    </Typography>
    <Typography variant="bodyW1" className="text-center text-[#637381]">
      {error || "Failed to load payout details. Please try again later."}
    </Typography>
    <Button size="sm" onClick={onRetry} fullWidth>
      Try Again
    </Button>
  </Stack>
);
